export default __webpack_public_path__ + "static/megabeutel-875ff3a55224369a2b6bcd31e291d3f9.jpg";